import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createStaticVNode as _createStaticVNode } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  fill: "none",
  viewBox: "0 0 48 48"
}
const _hoisted_2 = /*#__PURE__*/_createStaticVNode("<circle cx=\"39.5\" cy=\"20.5\" r=\"4\" stroke=\"#F69100\"></circle><circle cx=\"21.5\" cy=\"11.5\" r=\"4\" stroke=\"#F69100\"></circle><path stroke=\"#F69100\" d=\"m29 24-1.277-4.17A4 4 0 0 0 23.898 17h-4.686a4 4 0 0 0-3.863 2.965L14 25M23.4 25H6.5a2.5 2.5 0 0 0 0 5h5.938\"></path><path stroke=\"#F69100\" d=\"M13.121 28.577a1.421 1.421 0 0 1 2.758 0l.325 1.302a.5.5 0 0 1-.485.621h-2.438a.5.5 0 0 1-.485-.621z\"></path><path stroke=\"#F69100\" d=\"M14.061 40h8.161a2 2 0 0 0 2-2v-7.067L32 30.367l.901 7.812A2.056 2.056 0 0 0 37 37.944V26.705q0-.305-.095-.595a3.834 3.834 0 0 0-4.247-2.595l-12.655 2.017a2 2 0 0 0-1.672 2.204l.891 7.73-5.322.418A2.061 2.061 0 0 0 14.06 40Z\"></path><path stroke=\"#F69100\" d=\"M27 31v7.193a1.5 1.5 0 1 1-3 0v-1.568M22 21.5h3\"></path>", 6)
const _hoisted_8 = [
  _hoisted_2
]

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, [..._hoisted_8]))
}
export default { render: render }